// Generated by IcedCoffeeScript 1.7.1-b
(function() {
  exports.C = {
    "null": 0xc0,
    "false": 0xc2,
    "true": 0xc3,
    bin8: 0xc4,
    bin16: 0xc5,
    bin32: 0xc6,
    ext8: 0xc7,
    ext16: 0xc8,
    ext32: 0xc9,
    float: 0xca,
    double: 0xcb,
    uint8: 0xcc,
    uint16: 0xcd,
    uint32: 0xce,
    uint64: 0xcf,
    int8: 0xd0,
    int16: 0xd1,
    int32: 0xd2,
    int64: 0xd3,
    fix_ext1: 0xd4,
    fix_ext2: 0xd5,
    fix_ext4: 0xd6,
    fix_ext8: 0xd7,
    fix_ext16: 0xd8,
    str8: 0xd9,
    str16: 0xda,
    str32: 0xdb,
    array16: 0xdc,
    array32: 0xdd,
    map16: 0xde,
    map32: 0xdf,
    fix_str_min: 0xa0,
    fix_str_max: 0xbf,
    fix_array_min: 0x90,
    fix_array_max: 0x9f,
    fix_map_min: 0x80,
    fix_map_max: 0x8f,
    fix_array_count_mask: 0xf,
    fix_map_count_mask: 0xf,
    fix_str_count_mask: 0x1f,
    negative_fix_min: 0xe0,
    negative_fix_max: 0xff,
    negative_fix_mask: 0x1f,
    negative_fix_offset: 0x20,
    positive_fix_max: 0x7f,
    rpc_request: 0x00,
    rpc_response: 0x01,
    rpc_notify: 0x02
  };

}).call(this);
